import { usePermissions, useUser } from '@tyro/api';

export function useIsTyroneUser(): boolean {
  const { user } = useUser();
  const { isTyroUser } = usePermissions();
  return isTyroUser || Boolean(user?.isEmulatingAsTyroUser);
}
